import { snapToStep } from './rangeValue';

/**
 * Longitud máxima de `formatValue(v)` para `v` recorriendo la rejilla `min`…`max` con `step`
 * (tope de iteraciones para dominios enormes).
 */
export function maxFormattedTickStringLength(
  min: number,
  max: number,
  step: number,
  formatValue: (n: number) => string,
): number {
  let maxLen = Math.max(formatValue(min).length, formatValue(max).length);
  if (!(step > 0) || !Number.isFinite(step) || max < min) {
    return Math.max(1, maxLen);
  }
  const span = max - min;
  const tickCount = Math.floor(span / step + 1e-9) + 1;
  const limit = Math.min(tickCount, 5000);
  for (let i = 0; i < limit; i++) {
    const v = snapToStep(min + i * step, min, max, step);
    maxLen = Math.max(maxLen, formatValue(v).length);
  }
  maxLen = Math.max(maxLen, formatValue(snapToStep(max, min, max, step)).length);
  return Math.max(1, maxLen);
}
